// extracted by mini-css-extract-plugin
export default {"operationalColor":"#7ec37e","nonCriticalColor":"#e1cd80","criticalColor":"#da9898","beyondRepairColor":"#0c0c0c","totalColor":"rgba(0,0,0,0)","footer":"Footer_footer__zZCIA"};